import type { UUID } from "../../utils/uuid";

export interface CustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  url: string;
  tabName: string;
}

export interface EditableCustomDashboardConfig {
  id: UUID | null;
  enabled: boolean;
  url: string;
  tabName: string;
}

export interface StoredCustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  url: string;
  tab_name: string;
}

export interface LuzmoDashboardEmbedConfig {
  appServer: string;
  dashboardSlug: string;
}

export const toCustomDashboardConfig = ({
  id,
  enabled,
  url,
  tab_name,
}: StoredCustomDashboardConfig): CustomDashboardConfig => ({
  id,
  enabled,
  url: url.trim(),
  tabName: tab_name.trim(),
});

export const parseLuzmoDashboardUrl = (value: string): LuzmoDashboardEmbedConfig | null => {
  try {
    const url = new URL(value);
    const dashboardSlug = url.pathname.split("/").filter(Boolean).at(-1);
    if (
      url.protocol !== "https:" ||
      (url.hostname !== "luzmo.com" && !url.hostname.endsWith(".luzmo.com")) ||
      !dashboardSlug
    ) {
      return null;
    }
    return { appServer: `${url.origin}/`, dashboardSlug };
  } catch {
    return null;
  }
};

export const isValidDashboardUrl = (value: string): boolean =>
  parseLuzmoDashboardUrl(value) !== null;

export const visibleCustomDashboardConfigs = (
  dashboards: StoredCustomDashboardConfig[],
): CustomDashboardConfig[] =>
  dashboards.flatMap((dashboard) => {
    const config = toCustomDashboardConfig(dashboard);
    return config.enabled && config.tabName && isValidDashboardUrl(config.url) ? [config] : [];
  });
